module.exports = __webpack_public_path__ + "static/media/dot-a.c98e78e5.svg";